// Generated by ts-to-zod
import { z } from 'zod';
import { urlSchema } from '../../utils/codecUtils.schema';

export const labelSchema = z.object({
  id: z.number(),
  url: urlSchema,
  name: z.string(),
  color: z.string().optional().nullable(),
});
